import Vue from 'vue'
import Router from 'vue-router'


//路由导航冗余报错（路由重复）
const originalPush = Router.prototype.push
      Router.prototype.push = function push(location) {
        return originalPush.call(this, location).catch(err => err)
      }
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/website',
  routes: [
    {path:"/", redirect:"home",component: () => import('@/views/layout'),
    children: [
      {path:"/home", name: 'home',component:() => import('@/views/home')},
      {path:"/solutions", name: 'solutions',component:() => import('@/views/solution')},
      {path:'/cases',name: 'cases',component:() => import('@/views/case')},
      {path:'/products',name: 'products',component:() => import('@/views/product')},
      {path:'/aboutus',name: 'aboutus',component:() => import('@/views/about')},
      {path:'/news', name: 'news',component:() => import('@/views/news')},
      {path:'/trial', name: 'trial',component:() => import('@/views/trial')},
    ]
  },
  {
    path: '*',
    name: '*',
    component: () => import('@/views/default')
  }
  ],
  scrollBehavior(to,from,savedPosition){
    if(to.name !== 'cases'){
      if(savedPosition){
        return savedPosition;
      }else{
        return {x:0,y:0}
      }
    }
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js